import { memo, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FormField from "layouts/Flow Designer/components/FormField";
import KeyValueInputs from "./KeyValueInputs";
import PayloadEditor from "./PayloadEditor";
import { form } from "../schemas/form";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import OptionLabel from "./OptionLabel";
import StyledDivider from "./StyledDivider";
import { XmlEditor } from "./XmlEditor";
import { TextEditor } from "./TextEditor";
import { JavascriptEditor } from "./Javascript";
import { HtmlEditor } from "./HtmlEditor";
import { CssEditor } from "./CssEditor";

const PayloadContentTypeInputs = ({ allowEditWorkflow }) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const formRef = useContext(FormFieldsContext);
  const { payloadContentType, formData } = form.formField;
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const setPayloadContentTypeDefaultValue = () => {
    const value = payloadContentType.options.find(
      (option) => option.value === formRef?.values?.payloadContentType
    );
    setDefaultValue(value);
  };
  useEffect(() => {
    if (formRef?.values) {
      setPayloadContentTypeDefaultValue();
    }
  }, [formRef?.values?.payloadContentType]);

  const renderPayloadEditor = () => {
    switch (formRef?.values?.payloadContentType) {
      case "formData":
        return (
          <KeyValueInputs
            field={formData}
            fieldName="formData"
            buttonTitle="Add Form Data"
            isPayloadContent
            allowEditWorkflow={allowEditWorkflow}
          />
        );
      case "json":
        return <PayloadEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />;
      case "xml":
        return <XmlEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />;
      case "text":
        return <TextEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />;
      case "javascript":
        return (
          <JavascriptEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />
        );
      case "html":
        return <HtmlEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />;
      case "css":
        return <CssEditor isFlowActive={isFlowActive} allowEditWorkflow={allowEditWorkflow} />;
    }
  };

  return (
    <>
      <OptionLabel
        label="Response Body"
        name={payloadContentType.name}
        allowEditWorkflow={allowEditWorkflow}
      />
      <FormField
        type={payloadContentType.type}
        label={payloadContentType.label}
        name={payloadContentType.name}
        placeholder=""
        options={payloadContentType.options?.sortAlphabetical("value")}
        defaultValue={defaultValue}
        value={defaultValue}
        onChange={(value) => {
          if (isFlowActive || !allowEditWorkflow) return;

          if (value === "formData") {
            formRef?.setFieldValue(value, [{ key: "", value: "" }]);
          }
        }}
        isDisabled={isFlowActive || !allowEditWorkflow}
      />
      {renderPayloadEditor()}
      <StyledDivider />
    </>
  );
};

export default memo(PayloadContentTypeInputs);
